// extracted by mini-css-extract-plugin
export default {"container":"no-z","ratingLayout":"oo-z","ratingLabel":"po-z","nonInteractiveRatingLabel":"qo-z"};